import type { PreloadedState } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';

import thunk from 'redux-thunk';

import createSagaMiddleware from 'redux-saga';

import { NODE_ENV } from '@/_config/env';

import rootSaga from '@/Redux/Sagas';
import { reducers } from './reducers';

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

export const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: reducers,
    middleware: getDefaultMiddlewares => {
      return [
        ...getDefaultMiddlewares({
          serializableCheck: false,
          immutableCheck: false,
        }).concat(thunk),
        ...middlewares,
      ];
    },
    preloadedState,
    devTools: NODE_ENV !== 'production',
  });

export const store = setupStore();

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof reducers>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
